import React from 'react'
import { MdAccessTime } from 'react-icons/md';
import { RxDash } from 'react-icons/rx';
import { TbArrowBigRightLinesFilled } from 'react-icons/tb';
import { MdDelete } from "react-icons/md";
import { CalendarAPI } from '../../api/CalendarAPI';
import { rootAction } from '../../redux/reducer/rootReducer';
import { useDispatch } from 'react-redux';
import { CoachSchedulerAPI } from '../../api/CoachSchedulerAPI';
import { ScheduleStatus } from '../../util/CalendarUtil';


const options = {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
};
const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const ReservationBoxCheckout = ({ reservation, selectedClub, startLoading, finishLoading, schedule, isReservation, setIsUpdate }) => {
    const dispatch = useDispatch();
    const deleteScheduleFromCart = async () => {
        try {
            startLoading();
            const reqData = {
                scheduleId: schedule.scheduleId,
                clubId: selectedClub.clubId,
                status: ScheduleStatus.DELETE,
                recurrenceId: schedule.recurrenceId
                 
            }
            await CoachSchedulerAPI.updateScheduleStatus(reqData);
            setIsUpdate(true);
            dispatch(rootAction.setIsUpdateTotalSchedule(true));
        } catch (error) {
            console.log("error", error)
        } finally {
            finishLoading();
        }
    }

    const deleteReservationFromCart = async () => {
        try {
            startLoading();
            const response = await CalendarAPI.deleteReservation(reservation?.reservationId, selectedClub.clubId, { status: "DELETED" });
            dispatch(rootAction.setReservationPaymentStatus(({ status: true, type: 'deleted' })));
            finishLoading();
        } catch (error) {
            finishLoading();
        }
    }

    return (
        <div className="checkout_future_reservation_info">
            <MdDelete onClick={() => {
                if (selectedClub?.calendarType === 'RESERVATION_CALENDAR'){
                    deleteReservationFromCart();
                }else{
                    deleteScheduleFromCart();
                }
            }} className='delete_pending_reservation_btn' />
            <span></span>
            <div className='future_reservation_details'>
                <div className='reservation_checkout_details_heading'>
                    <h3>
                        {weekdays[new Date(isReservation ? reservation.reservationCheckIn : schedule?.scheduleStartTime).getUTCDay()]} - {new Date(isReservation ? reservation.reservationCheckIn : schedule?.scheduleEndTime).toLocaleString('en-US', options)}
                    </h3>
                    {isReservation ?
                        <p>{reservation.resourceName}</p>
                        :
                        <>
                            {schedule?.resourceName &&
                                <p>{schedule?.resourceName}</p>
                            }
                        </>
                    }
                </div>
                <div className='future_reservation_timing'>
                    <p><MdAccessTime className='future_reservation_timing_icon' />Timing <TbArrowBigRightLinesFilled className='future_reservation_arrow_icon' /></p>
                    <p>
                        {new Date(isReservation ? reservation.reservationCheckIn : schedule?.scheduleStartTime).toLocaleTimeString("en-US",
                            { timeZone: 'UTC', hour: '2-digit', minute: '2-digit', hour12: true }
                        )}
                        <RxDash />
                        {new Date(isReservation ? reservation.reservationCheckIn : schedule?.scheduleEndTime).toLocaleTimeString("en-US",
                            { timeZone: 'UTC', minute: '2-digit', hour: '2-digit', hour12: true }
                        )}

                    </p>
                </div>
            </div>
        </div>
    )
}

export default ReservationBoxCheckout